import React from 'react';
import * as resourceActions from 'ACTIONS/resources.actions';
import { Badge, Tag, Alert } from 'antd';
import { decode } from 'html-entities';
import moment from 'moment';
import { getUIStatus } from 'HELPERS/utils';
import ControlResource from 'PAGES/Control/Resource/ControlResource';
import { DataGrid, DataGridFilters } from 'COMPONENTS/DataGrid';
import { Summary } from '../../Summary';
import ResendNewsletterForm from './ResendNewsletterForm';
import { store } from '../../../../App';
import { RESOURCE_TYPE_ID } from '../../../../helpers/constants';

const filterClient = (id) => {
  const resource = 'resendNewsletter';
  const params = {
    client_id: id,
    page: 1,
    status_id: '',
    type_id: `${RESOURCE_TYPE_ID.RESEND_NEWSLETTER}`,
  };

  return store.dispatch(resourceActions.refetchResource(resource, params));
};

export const columns = [
  {
    title: 'Site Name',
    dataIndex: 'account',
    key: 'accounts.name',
    render: account => (
      <a target="_blank" rel="noreferrer" title="Access website" href={`http://${account.site}`}>
        {decode(account.name)}
      </a>
    ),
    sorter: true,
  },
  {
    title: 'Client',
    dataIndex: 'account',
    key: 'clients.name',
    render: ({ clients }) => (clients)
      && clients.map(client => (
        <Tag style={{ cursor: 'pointer' }} key={`client_${client.id}`} onClick={() => filterClient(client.id)}>
          {decode(client.name) || (client.cap_client_id || client.id)}
        </Tag>
      )),
    sorter: true,
  },
  {
    title: 'MailChimp Account',
    dataIndex: 'account',
    key: 'accounts.mailchimp_account',
    render: account => account.mailchimp_account,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status_id',
    width: 90,
    // eslint-disable-next-line
    render: ({ status }) => <Badge key="status_badge" status={getUIStatus(status)} text={status} />,
    sorter: true,
  },
  {
    title: 'Details',
    dataIndex: 'details',
    key: 'details',
    sorter: true,
  },
  {
    title: 'Last Update',
    dataIndex: 'updated_at',
    key: 'updated_at',
    render: value => moment(value).format('LLL'),
    sorter: true,
  },
];

const alertMessage = (
  <Alert
    message="Sending newsletters"
    description={
      <div>
        Newsletters are sent automatically on newsletter day at 9am local time.
        This tool is only for newsletters that were missed or have failed to send.
      </div>
    }
    type="info"
    showIcon
  />
);

const ResendNewsletter = () => (
  <ControlResource
    resource="resendNewsletter"
    resourceTypeId={RESOURCE_TYPE_ID.RESEND_NEWSLETTER}
    title="Resend newsletter"
    renderBefore={
      () => (
        <div className="alert-summary">
          {alertMessage}
          <Summary
            resource="resendNewsletter"
            resourceTypeId={RESOURCE_TYPE_ID.RESEND_NEWSLETTER}
            lastUpdateMessage="Newsletter was successfully resent"
          />
        </div>
      )
    }
    form={<ResendNewsletterForm />}
    filterForm={<DataGridFilters />}
  >
    <DataGrid
      columns={columns}
      search={null}
      tableProps={{
        rowKey: record => record.id,
        bordered: true,
      }}
    />
  </ControlResource>
);

export default ResendNewsletter;



// WEBPACK FOOTER //
// ./src/pages/Control/Screens/ResendNewsletter/ResendNewsletter.js